import { logger } from '@/tools/logger';
import { sleep } from '@/tools/sleep';
let callID = 0;
const resolverMap = new Map();
window.nativeOnMessage = callResult => {
	const resolver = resolverMap.get(callResult.id);
	if (resolver) {
		/**
		if (resolver.method !== callResult.method) {
			console.error(
				`interfaceNative: nativeOnMessage: resolvers method ${resolver.method} is not matching ${callResult.method}`
			);
		} **/
		resolverMap.delete(callResult.id);
		resolver.resolve(callResult.result);
	} else {
		logger.error('interfaceNative: nativeOnMessage could not find resolver', resolver);
	}
};
export function nativeMethodCall(_options = {}) {
	const options = Object.assign(
		{
			resultTransform: result => result,
		},
		_options
	);
	return new Promise(resolve => {
		if (window.nativeInterface && typeof window.nativeInterface[options.method] === 'function') {
			if (options.params)
				resolve(options.resultTransform(window.nativeInterface[options.method](...options.params)));
			else resolve(options.resultTransform(window.nativeInterface[options.method]()));
		} else if (
			window.webkit &&
			window.webkit.messageHandlers &&
			window.webkit.messageHandlers.nativeInterface &&
			window.webkit.messageHandlers.nativeInterface
		) {
			const jsonRPCObject = {
				method: options.method,
				params: options.params,
				id: ++callID,
			};
			// logger.log('interfaceNative: nativeMethodCall: RPCObject', jsonRPCObject);
			resolverMap.set(
				jsonRPCObject.id,
				Object.assign(jsonRPCObject, { resolve: result => resolve(options.resultTransform(result)) })
			);
			window.webkit.messageHandlers.nativeInterface.postMessage(JSON.parse(JSON.stringify(jsonRPCObject)));
		} else {
			logger.log(`Warning: ${options.method} not implemented`);

			/* eslint-disable no-nested-ternary */
			return resolve(
				options.fallback
					? options.params
						? options.fallback(...options.params)
						: options.fallback()
					: undefined
			);
		}
	}); // list is newline-separated
}

const appDoLog = logMessage =>
	nativeMethodCall({
		method: 'nativeAppDoLog',
		params: [logMessage],
		transform: () => true,
		fallback: logMessage => logger.log('nativeLog: ' + logMessage),
	});

export async function initializeNativeInterface(waitForNative) {
	logger.log('native Interface not up wait for it!', waitForNative);
	if (waitForNative) {
		while (
			!window.nativeInterface &&
			!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeInterface)
		) {
			// Always show this warning even if loggs are off
			// since this is an endless loop that might not finish.
			logger.warn('native Interface not up wait for it!');
			await sleep(100);
		}
		if (process.env.NODE_ENV === 'production') {
			logger.log = appDoLog;
			logger.warn = appDoLog;
		}
	}
}
